import type { StatusSettingListItem } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/architecture/types/architectureWidgetSettings.types';
import type { FormattingOptions } from '@/dashboard/features/widgetSettings/editModeWidgetSettings/components/common/fontFormattingOption.setup';

export interface StatusSummaryBaseOption {
  statusSettings: StatusSettingListItem[];
}

export interface StatusSummaryPieOption extends StatusSummaryBaseOption {
  showLegend: boolean;
  markerInfo: { show: boolean; showTotal: boolean };
}

export interface StatusSummaryCardOption extends StatusSummaryBaseOption {
  formatting: FormattingOptions;
}

export type StatusSummaryOption = StatusSummaryPieOption & StatusSummaryCardOption;

export const DEFAULT_STATUS_SUMMARY_CHART_OPTION: StatusSummaryOption = {
  showLegend: true,
  markerInfo: { show: true, showTotal: true },
  statusSettings: [],
  formatting: {
    title: {
      textSize: 14,
      isAuto: true,
      horizontalAlign: 'left',
    },
    value: {
      textSize: 40,
      isAuto: true,
      verticalAlign: 'bottom',
      horizontalAlign: 'right',
    },
  },
};
